import { type RouteObject } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';

export const BannerRoutes: RouteObject[] = [
  {
    path: ROUTES_PATH.bannerManagement,
    children: [
      { index: true, lazy: () => import('./banner-list') },
      { path: 'new', lazy: () => import('./banner-new') },
      { path: ':id', lazy: () => import('./banner-detail') },
    ],
  },
];
